import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Indicator from '../header/Indicator';
import {
    Menu18x14Svg,
    Search20Svg,
} from '../../svg';
import { mobileMenuOpen } from '../../store/mobile-menu';
import Search from '../header/Search';

class MobileHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchOpen: false,
        };
        this.searchInput = React.createRef();
    }

    componentDidUpdate(prevProps, prevState) {
        const { searchOpen } = this.state;

        if (searchOpen && searchOpen !== prevState.searchOpen && this.searchInput.current) {
            this.searchInput.current.focus();
        }
    }

    handleOpenSearch = () => {
        this.setState(() => ({ searchOpen: true }));
    };

    handleCloseSearch = () => {
        this.setState(() => ({ searchOpen: false }));
    };

    render() {
        const { openMobileMenu, locale } = this.props;
        const { searchOpen } = this.state;
        const searchClasses = classNames('mobile-header__search', {
            'mobile-header__search--open': searchOpen,
        });
        let logo;

        if (locale === 'sq') {
            logo = (
                <div className="mobile-header__logo">
                    <Link
                        aria-label="home"
                        to="/"
                        name="link"
                        rel="link"
                    >
                        <img src="/images/logot/MFPT_SHQ.png" alt="" />
                    </Link>
                </div>
            );
        } else if (locale === 'en') {
            logo = (
                <div className="mobile-header__logo">
                    <Link
                        aria-label="home"
                        to="/"
                        name="link"
                        rel="link"
                    >
                        <img src="/images/logot/MFPT_EN.png" alt="" />
                    </Link>
                </div>
            );
        } else if (locale === 'sr') {
            logo = (
                <div className="mobile-header__logo">
                    <Link
                        aria-label="home"
                        to="/"
                        name="link"
                        rel="link"
                    >
                        <img src="/images/logot/MFPT_SER.png" alt="" />
                    </Link>
                </div>
            );
        }

        return (
            <div className="mobile-header">
                <div className="mobile-header__panel">
                    <div className="container">
                        <div className="mobile-header__body">
                            <button aria-label="open menu" name="mobile menu" type="button" className="mobile-header__menu-button" onClick={openMobileMenu}>
                                <Menu18x14Svg />
                            </button>
                            {logo}
                            <Search
                                context="mobile-header"
                                className={searchClasses}
                                inputRef={this.searchInput}
                                onClose={this.handleCloseSearch}
                            />
                            <div className="mobile-header__indicators">
                                <Indicator
                                    className="indicator--mobile indicator--mobile-search d-md-none"
                                    onClick={this.handleOpenSearch}
                                    icon={<Search20Svg />}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cart: state.cart,
    wishlist: state.wishlist,
    locale: state.locale,
});

const mapDispatchToProps = {
    openMobileMenu: mobileMenuOpen,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MobileHeader);
